import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import { ReactNode } from 'react';

function CommandsConfirmationModal({
  children,
  open,
  onClose,
  onConfirm,
}: {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ p: 4, mt: 2 }}>{children}</DialogContent>
      <DialogActions
        sx={{ display: 'flex', p: 2, justifyContent: 'space-between' }}
      >
        <Button onClick={onConfirm} autoFocus variant='contained'>
          <FormattedAlias id='Yes' />
        </Button>
        <Button onClick={onClose} variant='outlined'>
          <FormattedAlias id='Cancel' />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CommandsConfirmationModal;
